const epr = {
  eprReport: "EPR declaration",
  country: "Jurisdiction",
  reportType: "EPR category",
  year: "Year",
  reportsEPR: "Reports EPR - Informes EPR",
  eprReporting: "EPR declarations",
  fillEPRHere: "Here you can fill your EPR declarations",
  fillEPRReport: "Fill EPR declaration",
  periodStart: "Period start",
  periodEnd: "Period end",
  totalSum: "Total amount",
  declaredQuantityKg: "Declared quantity (kg)",
  ecoFeeDue: "Eco-fee due",
  setEcoFeeDue: "Set Eco-fee due",
  addEPRReportToSeeData: "Add EPR report to see the data",
  addEPRReport: "Add EPR report",
  returnParameters: "Return parameters",
  editPackagingData: "Edit packaging data",
  summary: "Summary",
  name: "Name",
  glass: "Glass",
  paperPaperboardCardboard: "Paper/paperboard/cardboard",
  ferrousMetals: "Ferrous metals",
  aluminium: "Aluminium",
  plastic: "Plastic",
  beverageCartonPackaging: "Beverage carton packaging",
  otherCompositesPackaging: "Other Composites packaging",
  otherMaterials: "Other materials",
  paper: "Paper",
  steel: "Steel",
  wood: "Wood",
  numberOfScu: "Number of CSU",
  other: "Other",
  submit: "Submit",
  save: "Save",
  downloadReport: "Download report",
  back: "Back",
  warning: "Warning",
  furnitureEcoparticipations: "Furniture ecoparticipations",
  revenueExcludingVAT: "Revenue excluding VAT",
  code: "Code",
  tarifHT: "Tarif HT",
  tarifTTC: "Tarif TTC",
  codeEcopart: "Code Ecopart",
  number: "Number",
  summ: "Amount",
  category: "Category",
  product: "Product",
  material: "Material",
  feature: "Characteristic",
  addRecord: "Add Record",
  success: "Success",
  edit: "Edit",
  kg: "Kg",
  weight: "Weight",
  eprReportSuccessfullySubmitted: "EPR Report was successfully submitted!",
  eprReportSuccessfullyCreated: "EPR Report was successfully created!",
  cancel: "Cancel",
  delete: "Delete",
  areYouSureToDelete: "Are you sure you want to delete this item?",
  period: "Period",
  uploadTransactions: "Upload Transactions",
  submitDisclaimer:
    "By clicking on the Submit button you agree to the following: When you submit this EPR information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution.",
  transactionsUploadInProgress: "Transactions upload is still in progress!",
  confirmMoveForwardWithUnfinishedUpload:
    "I confirm that I want to move forward with EPR report filing with transactions upload process unfinished.",
  transactionsUploadInProgressMessage:
    "Transactions upload is in progress. It may take from 5 to 30 mins for it to finish depending on the amount of your transactions.",
  noActiveIntegration:
    'No active integration. Please complete an integration in "Stores" section to be able to upload your transactions.',
  yes: "Yes",
  no: "No",
  productTypologies: "Product typologies",
  productTypology: "Product typology",
  editTextileData: "Edit textile data",
  clothing: "Clothing",
  householdLinen: "Household linen",
  footwear: "Footwear",
  selectDeclarationMethod: "Available declaration methods",
  detailedDeclaration: "Detailed declaration",
  fourTypesOfReportingParameters:
    "4 types of reporting parameters for each item",
  volumesDeclaredPerProductLine: "Volumes declared per product line",
  standardScale: "Standard scale",
  simplifiedDeclaration: "Simplified declaration",
  twoStepsDeclaration: "2 steps declaration",
  volumesDeclaredPerProductFamily:
    "Volumes declared per product family (Clothing, Household linen, Footwear)",
  pricePerItemIncreased: "Price per item is increased",
  revenue: "Revenue",
  tax: "Tax",
  fee: "Fee",
  productDescription: "Product description",
  uploadPaymentMemo: "Upload payment memo file",
  quantity: 'Quantity',
  quantityIntegerOnly: "Only whole numbers allowed",
  fieldRequired: "This field is required",
  skip: "Skip",
  totalWeightKg: "Total weight (Kg)",
  quantityWithoutBreakdownNote: "Quantity – (without per-category breakdown for the Netherlands)",
  selectPackagingCategories: "Select packaging categories",
  guides: {
    subtitle: "Find instructions for filling EPR declarations by Jurisdiction.",
    searchPlaceholder: "Search Jurisdiction...",
    emptyState: "No guides found matching your search.",
    contactText: "Looking for something else?",
    contactLink: "Contact us",
    table: {
      country: "Jurisdiction",
      category: "Category",
      lastUpdated: "Last updated",
      language: "Language",
      action: "Action",
      viewPdf: "View PDF"
    }
  }
};

export default {
  ...epr,
  packagingSku: {
    pageTitle: "Packaging SKU",
    pageSubtitle: "Assign packaging types to product SKUs for EPR reporting.",
    menu: {
      products: "Packaging SKU",
      dashboard: "Dashboard",
      reports: "Reports",
      dataEditor: "Data editor",
      help: "Help",
    },
    placeholders: {
      productsTitle: "No SKUs yet",
      productsDescription: "Map packaging rules to products here — the same catalog as in the Shopify app, on Lappa.",
    },
    tabs: {
      primary: "Primary",
      shipping: "Shipping",
    },
    table: {
      id: "ID",
      name: "Name",
      type: "Type",
      weight: "Weight",
      length: "Length",
      height: "Height",
      width: "Width",
      actions: "Actions",
    },
    loadError: "Could not load packages.",
    actions: {
      edit: "Edit",
      delete: "Delete",
    },
    edit: {
      title: "Edit packaging",
      submit: "Save",
      saveError: "Could not update packaging.",
    },
    delete: {
      title: "Delete packaging",
      description: "Are you sure you want to delete {{name}}?",
      confirm: "Delete",
      cancel: "Cancel",
      error: "Could not delete packaging.",
    },
    add: {
      title: "Add packaging",
      submit: "Add packaging",
      cancel: "Cancel",
      name: "Packaging name",
      namePlaceholder: "Enter packaging name",
      type: "Type",
      typePrimary: "Primary (product packaging)",
      typeShipping: "Shipping (transport packaging)",
      store: "Store",
      storePlaceholder: "Select store",
      weight: "Total weight",
      length: "Length",
      height: "Height",
      width: "Width",
      errorName: "Enter the packaging name.",
      errorNameLength: "Name must be 255 characters or fewer.",
      errorType: "Select the packaging type.",
      errorStore: "Select a store.",
      errorWeight: "Enter a weight greater than 0.",
      errorDimension: "Enter a value greater than 0.",
      saveError: "Could not create packaging.",
    },
    composition: {
      title: "Packaging composition",
      intro: "Add and describe all components that make up this packaging.",
      add: "Add packaging component",
      addComponent: "Add component",
      saveComponent: "Save component",
      component: "Component",
      material: "Material",
      weight: "Weight",
      percent: "% of total",
      actions: "Actions",
      creation: "Component creation",
      manual: "Manual",
      aiAssisted: "AI Assisted",
      aiSuggestion: "AI suggestion",
      aiPlaceholder: "Select suggestion",
      componentType: "Component type",
      componentTypePlaceholder: "Select component type",
      customComponentType: "Custom component type",
      materialFamily: "Material family",
      materialFamilyPlaceholder: "Select material family",
      customMaterialFamily: "Custom material family",
      materialSubtype: "Material subtype",
      materialSubtypePlaceholder: "Select material subtype",
      rigidOrFlexible: "Rigid or flexible?",
      pcr: "Post-consumer recycled content (%)",
      bioBased: "Bio-based content (%)",
      biodegradable: "Is the plastic biodegradable?",
      compostable: "Is it compostable?",
      componentWeight: "Component weight",
      weightPlaceholder: "Weight",
      percentOfTotal: "Percentage of total packaging weight",
      separable: "Can the consumer separate this component?",
      selectOption: "Select option",
      recyclingCode: "Recycling Code",
      recyclingCodePlaceholder: "Select recycling codes",
      sortingInstruction: "Sorting Instruction",
      sortingInstructionPlaceholder: "Select sorting instruction",
      reusable: "Reusable or refillable",
      recycledDescription: "Recycled content description",
      recycledDescriptionPlaceholder: "Describe recycled content",
      recyclingStream: "Intended recycling stream",
      recyclingStreamPlaceholder: "Select recycling stream",
      notes: "Additional notes",
      notesPlaceholder: "Additional notes",
    },
  },
};
